import { render, staticRenderFns } from "./zuopinInfo.vue?vue&type=template&id=ed415978&scoped=true&"
import script from "./zuopinInfo.vue?vue&type=script&lang=js&"
export * from "./zuopinInfo.vue?vue&type=script&lang=js&"
import style0 from "./zuopinInfo.vue?vue&type=style&index=0&id=ed415978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed415978",
  null
  
)

export default component.exports